import React from 'react';
import ReactGA from 'react-ga';
// import YoutubePlayer from 'react-youtube-player';
import ReactPlayer from 'react-player'
import download from './../../images/icon/ic_download.png'
import facebook from './../../images/icon/ic_facebook.png'
import instagram from './../../images/icon/ic_instagram.png'
import youtube from './../../images/icon/ic_youtube.png'
import video_dog from './../../images/dog.mp4'

class HeaderContents extends React.Component {
    handleClick(key) {
        var value = "";
        switch (key) {
            case 1:
                value = "app store-1";
                break;

            case 2:
                value = "facebook";
                break;

            case 3:
                value = "instagram"
                break;

            case 4:
                value = "youtube";
                break;
        }
        ReactGA.event({
            category: 'WEB',
            action: value,
        });
    }

    render(){
        return (
            <div className="header-ceontent">
                <div className='video-wrapper'>
                    <ReactPlayer url={video_dog} playing 
                        height='100%' width='100%' loop/>
                </div>
                {/* <YoutubePlayer
                    videoId='q-aipKmNDEk'
                    height = '100%'
                    // playbackState='playing'
                    configuration={
                        {
                            playlist : 'q-aipKmNDEk',
                            loop: 1,
                            rel : 0,
                            showinfo: 0,
                            controls: 0, //paly controls remove
                            disablekb: 1, //keyboard control remove
                            modestbranding: 1 //youtube logo remove
                        }
                    }
                /> */}
                <div className="video-overlay"></div>
                <div className="video-description">
                    <p className="title">MEONGCA</p>
                    <p className="sub-title">camera APP for dogs</p>
                    <a target="_blank" onClick={()=>{this.handleClick(1)}} href="https://itunes.apple.com/kr/app/meongca/id1369505051?l=en&mt=8">
                        <img className="btn-download" src={download} alt="download button"/>
                    </a>
                    <p className="links">
                        <a target="_blank" onClick={()=>{this.handleClick(2)}} href="//www.facebook.com/Naplab-360679287757142/">
                            <img src={facebook} alt="facebook button"/>
                        </a>
                        <a target="_blank" onClick={()=>{this.handleClick(3)}} href="https://www.instagram.com/meongcagram/">
                            <img src={instagram} alt="instagram button"/>
                        </a>
                        <a target="_blank" onClick={()=>{this.handleClick(4)}} href="https://www.youtube.com/watch?v=q-aipKmNDEk">
                            <img src={youtube} alt="youtube button"/>
                        </a>
                    </p>
                </div>
            </div>
        )
    }

}

export default HeaderContents;


// WEBPACK FOOTER //
// ./src/components/header/HeaderContents.js